import { post } from '..';

const createUser = async (
  email: string,
  firstName: string,
  lastName: string,
  isAdmin: boolean,
  roleId?: string,
) => post('users/v3', {
  email,
  firstName,
  lastName,
  isAdmin,
  roleId: roleId || undefined,
});

export default createUser;
